export const getPageEditorUrl = (pageId: number) => {
  return `${window.location.origin}/dashboard/page/${pageId}/edit`
}

export const getPageTemplatePreviewUrl = (pageId: number) => {
  return `${window.location.origin}/dashboard/page/template/${pageId}/show`
}

export const getPageTemplateEditorUrl = (pageId: number) => {
  return `${window.location.origin}/dashboard/page/template/${pageId}/edit`
}
